/**
 * Mobile Search Toggle Functionality
 * Handles toggling the mobile search bar visibility
 */
(function() {
  'use strict';

  window.toggleMobileSearch = function(event) {
    // Stop event propagation to prevent click.away from firing
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    // Try to find the mobile search bar, fall back to desktop search bar
    var searchBar = document.getElementById('mobile-search-bar') || document.getElementById('desktop-search-bar');
    if (!searchBar) {
      console.error('Search bar not found');
      return;
    }

    var isHidden = searchBar.classList.contains('mobile-hidden') ||
                   window.getComputedStyle(searchBar).display === 'none';

    if (isHidden) {
      searchBar.classList.remove('mobile-hidden');
      searchBar.classList.add('mobile-visible');
      searchBar.style.display = ''; // Clear any inline style
      if (window.Alpine && window.Alpine.store) {
        window.Alpine.store('xModal').setActiveElement('SearchOpen');
      }
      setTimeout(function() {
        var input = document.querySelector('#header-search-in-modal');
        if (input) input.focus();
      }, 100);
    } else {
      searchBar.classList.remove('mobile-visible');
      searchBar.classList.add('mobile-hidden');
      if (window.Alpine && window.Alpine.store) {
        window.Alpine.store('xModal').setActiveElement('');
      }
    }
  };

  // Initialize event listeners using proper event binding
  document.addEventListener('DOMContentLoaded', function() {
    var mobileSearchIcon = document.getElementById('mobile-search-icon');
    if (mobileSearchIcon) {
      var searchLink = mobileSearchIcon.querySelector('a');
      if (searchLink) {
        searchLink.addEventListener('click', window.toggleMobileSearch);
      }
    }
  });
})();
